import { ReactNode } from 'react';
import styled from 'styled-components';

interface LayoutWrapperProps {
  children: ReactNode;
}

const Container = styled.div`
  max-width: ${({ theme }) => theme.breakpoints.wideSuper}px;
  height: 100%;
  margin: 0 auto;
`;

const LayoutWrapper = ({ children }: LayoutWrapperProps) => <Container>{children}</Container>;

export default LayoutWrapper;
export { Container as LayoutWrapperStyles };
